/**
 *
 * PatientOverview
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import History from "utils/history";
import GlobalMessages from "messages/messages";
import Search from "basicComponents/Searchv2/Searchv2";
import { ICONS } from "basicComponents/Searchv2/Icons";

class PatientOverview extends Component {
  static propTypes = {
    patients: PropTypes.array,
    intl: PropTypes.object.isRequired,
    onFilter: PropTypes.func.isRequired,
    practice: PropTypes.any.isRequired,
    onEditPatient: PropTypes.func.isRequired,
    initialInputText: PropTypes.string,
    showArrow: PropTypes.bool,
    items: PropTypes.array.isRequired,
    maxHeight: PropTypes.bool,
    showTableContent: PropTypes.bool,
    onPatientClicked: PropTypes.func,
    onHandleNewPatient: PropTypes.func,
    enableIcons: PropTypes.bool,
  };

  static defaultProps = {
    showArrow: true,
    initialInputText: "",
    maxHeight: false,
  };

  state = {
    inputText: this.props.initialInputText,
    doneTyping: true,
  };

  searchTimeout = -1;

  handleChange = e => {
    this.setState({
      inputText: e.target.value,
    });

    this.doneTyping(false);

    if (this.searchTimeout !== -1) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(() => {
      if (e.target.value.length <= 0) {
        this.props.resetPatients();
        this.doneTyping(true);
      } else {
        this.props.onFilter({ filter: e.target.value }, this.props.practice.id);
        this.doneTyping(true);
      }
    }, 300);
  };

  doneTyping = done => {
    this.setState({ doneTyping: done });
  };

  // TODO: Pass patient object to /newTreatment page.
  handleArrowClicked = () => {
    History.push({
      pathname: "/patients",
      searchText: this.state.inputText,
    });
  };

  handleIconClicked = (icon, patient) => {
    switch (icon) {
      case ICONS.ADD:
        this.props.onEditPatient(patient, icon);
        break;
      case ICONS.EDIT:
        this.props.onEditPatient(patient, icon);
        break;
      case ICONS.SHOW_MORE:
        History.push(`/patient/${patient.id}`);
        break;
      default:
        break;
    }
  };

  handlePatientOnClick = patient => {
    History.push(`/patient/${patient.id}`);
    // const goToTreatmentFlow =
    //   History.location &&
    //   History.location.state &&
    //   History.location.state.goToTreatmentFlow;
    // if (goToTreatmentFlow) {
    //   History.push(`/treatment/edit/${patient.id}`, {
    //     fromTreatmentFlow: true,
    //     searchedDate: History.location?.state?.searchedDate,
    //   });
    // } else {
    //   History.push(`/patient/${patient.id}`);
    // }
  };

  handleUglyButtonClicked = () => {
    this.save(() => {
      this.props.onFilter(
        this.props.value ? this.props.value : { filter: this.state.inputText },
        this.props.practice.id,
      );
    });
  };

  save = callback => {
    const val = this.props.value || this.state.inputText;
    let routeState = {};
    const goToTreatmentFlow =
      History.location &&
      History.location.state &&
      History.location.state.goToTreatmentFlow;
    if (parseInt(val.replace(/-|_|#|\/|\s/g, ""), 10)) {
      routeState = {
        internalRef: val,
        goToTreatmentFlow,
      };
    } else {
      routeState = {
        name: val,
        goToTreatmentFlow,
      };
    }
    History.push(`/patients/new`, routeState);
  };

  componentDidUpdate(){
    setTimeout(() => {
      let x = document.querySelector('#overviewtable')
      let rows = x.querySelectorAll('[role="rowgroup"]')
      for(var i = 0; i < rows.length; i++){
        let row = rows[i]
        let cel = row.firstChild.childNodes[2]
        cel.title = this.props.items[i].nl
      }
    }, 1000);
  }

  render() {
    return (
      <Search
        noResultButtonId="addNewPatientButton"
        enableIcons={false}
        onClick={
          this.props.onPatientClicked
            ? this.props.onPatientClicked
            : (state, { original }) => this.handlePatientOnClick(original)
        }
        icons={[]}
        id="PatientOverviewSearch"
        doneTyping={this.state.doneTyping}
        loading={this.props.loading}
        items={this.props.items}
        placeholder={"Zoek"}
        enableUglyLongButton
        iconButtonText={window.innerWidth > 500 ? "Voeg nieuwe patiënt toe" : ""}
        handleUglyButtonClicked={this.handleUglyButtonClicked}
        value={this.props.onChange ? this.props.value : this.state.inputText}
        maxHeight={this.props.maxHeight}
        height={this.props.maxHeight ? 500 : 200}
        showArrow={this.props.showArrow}
        arrowId="patientArrowButton"
        handleArrowClicked={this.handleArrowClicked}
        practice={this.props.practice}
        showTableContent={!!this.state.inputText || this.props.showTableContent}
        onChange={this.props.onChange || this.handleChange}
        showPaginationBottom={this.props.showPaginationBottom}
        headers={[
          {
            Header: <FormattedMessage {...GlobalMessages.patientId} />,
            accessor: "name",
            minWidth: 90,
          },
          {
            Header: <FormattedMessage {...GlobalMessages.internal_ref} />,
            accessor: "internalRef",
            minWidth: 90,
          },
          // {
          //   Header: <FormattedMessage {...GlobalMessages.caseNr} />,
          //   accessor: "caseId",
          //   minWidth: 100,
          // },
          {
            Header: <div>Productnaam</div>,
            accessor: "productname",
            minWidth: 100,
          },
          {
            Header: <div>Leverdatum</div>,
            accessor: "leverdatum",
            minWidth: 100,
          },

          {
            Header: <div>Afspraaktype</div>,
            accessor: "afspraaknaam",
            minWidth: 100,
          },
          {
            Header: <div>Datum afspraak</div>,
            accessor: "planned_date_time_from",
            minWidth: 100,
          },

        ]}
      />
    );
  }
}

export default injectIntl(PatientOverview);
